module.exports = __webpack_public_path__ + "img/vote_silver.6cf2836d.png";